import { cva } from "class-variance-authority";

/**
 * Canonical toggle-chip look — single source for the filter/segment chips that
 * were drifting between `SegChip` (venue-editor) and `DashboardFilters` (dashboard).
 * Quiet primary tint when active; muted with hover otherwise. Both primitives
 * consume this so an active chip renders identically across every surface.
 */
export const chipVariants = cva(
  "inline-flex items-center justify-center gap-1.5 border font-medium transition-colors disabled:opacity-50 disabled:pointer-events-none",
  {
    variants: {
      size: {
        sm: "h-8 px-3 text-xs",
        md: "h-9 px-3.5 text-sm",
      },
      /* `pill` = el chip de las piezas de redes (999px + hairline + mono).
         Reservado a superficies públicas; el default sigue siendo `rounded`
         para no mover los filtros del dashboard. */
      shape: {
        rounded: "rounded-xl",
        pill: "rounded-full",
      },
      active: {
        // Neutral (white in dark, ink in light) active state — the brand blue
        // was overused as the generic "selected" signal across every filter.
        true: "border-foreground/25 bg-foreground/10 text-foreground",
        false:
          "border-border/60 text-muted-foreground hover:bg-muted hover:text-foreground",
      },
    },
    defaultVariants: { size: "md", shape: "rounded", active: false },
  },
);
